module.exports = "<svg viewBox=\"0 0 24 18\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M21 18H3c-1.654 0-3-1.346-3-3V3c0-1.654 1.346-3 3-3h18c1.654 0 3 1.346 3 3v12c0 1.654-1.346 3-3 3zM3 16h18c.551 0 1-.449 1-1V3.203l-9.372 7.575a.996.996 0 0 1-1.256 0L2 3.203V15c0 .551.449 1 1 1zM20.307 2H3.693L12 8.715 20.307 2z\" fill=\"#FFF\" fill-rule=\"evenodd\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-inline-loader?removeTags=true!./src/images/svg/email.svg
// module id = KPF2
// module chunks = 89